module.exports = "mutation addTagsToProduct($id:ID!,$tagIds:String!){addTagsToProduct(id:$id,tagIds:$tagIds)}"